import styled from "@emotion/styled";
import photocircle from './assets/photocircle.png'

export const CenterBox = styled.div`
position: absolute;
left: 0;
width: 100%;
display: flex;
justify-content: center;
`

export const CenterDiv = styled.div`
position: relative;
left: 0;
width: 100%;
display: flex;
justify-content: center;
`

interface SectionTitleProps {
    top: string
    title: string
    subTitleLeft: string
    subTitleRight: string
    titleColor?: string
}

export const SectionTitle = (props: SectionTitleProps) => {
    const { top, title, subTitleLeft, subTitleRight, titleColor } = props
    const color = titleColor ? titleColor : 'black'
    return <CenterBox style={{ top: top, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <h2 style={{ letterSpacing: '0.8rem', marginBottom: '0', color: color }}>{title}</h2>
        <div className={'sy-bold'} style={{ fontSize: '2.4rem', letterSpacing: '0.1rem' }}>
            <span style={{ color: '#c5c5c5', paddingRight: '0.4rem' }} >{subTitleLeft}</span>
            <GoldenSpan style={{ paddingLeft: '0.4rem' }} >{subTitleRight}</GoldenSpan>
        </div>
    </CenterBox>
}

interface BusinessSummaryProps {
    img: string
    title: string
    content: string
}

export const BusinessSummary = (props: BusinessSummaryProps) => {
    const { img, title, content } = props
    return <OneBusiness>
        <MBImg src={img} alt={title} />
        <MBTile>{title}</MBTile>
        <MBLine />
        <MBContent>{content}</MBContent>
    </OneBusiness>
}

const OneBusiness = styled.div`
width: 26rem;
display: flex;
flex-direction: column;
align-items: center;
`

const MBImg = styled.img`
object-fit: cover;
`
const MBTile = styled.h3`
margin-top: 4rem;
font-size: 2rem;
color: #666666;
font-weight: 700;
`

const MBLine = styled.div`
position: relative;
width: 6rem;
height: 2px;
border-top: 2px solid #666666;
margin-top: 1rem;
`

const MBContent = styled.span`
margin-top: 2.8rem;
font-size: 2rem;
color: #666666;
`

interface SoulFigureSummaryProps {
    img: string
    name: string
    title: string
    content: string
}


export const SoulFigureSummary = (props: SoulFigureSummaryProps) => {
    const { img, name, title, content } = props

    return <OneBusiness style={{ width: '32rem' }}>
        <div style={{ position: 'relative', width: '20.7rem', height: '20.7rem', marginBottom: '1.5rem' }}>
            <img src={photocircle} alt={''} style={{ position: 'absolute', left: '0', top: '0', objectFit: 'cover' }} />
            <img src={img} alt={name} style={{ position: 'absolute', left: '0.95rem', top: '0.95rem', objectFit: 'cover' }} />
        </div>
        <div>
            <span className={'sy-bold'} style={{ fontSize: '2rem', color: '#565656', paddingRight: '0.5rem' }}>{name}</span>
            <span className={'sy-bold'} style={{ fontSize: '2rem', paddingLeft: '0.5rem', color: '#d2bf92' }}>{title}</span>
        </div>
        <MBContent style={{ fontSize: '1.6rem', lineHeight: '3rem', marginTop: '1.5rem' }}>{content}</MBContent>
    </OneBusiness>
}

export const ContentSpan = styled.span`
font-size: 1.7rem;
line-height: 4rem;
`

export const GoldenSpan = styled.span`
color: #d2bf92;
`

interface PhotoFrameProps extends React.HTMLAttributes<HTMLDivElement> {
    photo: string
    captions: string[]
    width: number
}

export const PhotoFrame = (props: PhotoFrameProps) => {
    const { photo, captions, width, style, ...restPorps } = props
    const show = captions.length > 0 ? 'Flex' : 'None'
    return <div style={{ ...style, position: 'relative'}} {...restPorps} >
        <MBImg style={{ position: 'relative', width: width }} src={photo} alt='Photo' />
        <div style={{ display: show, flexDirection: 'column', justifyContent: 'center', alignItems: 'center', position: 'absolute', bottom: '0rem', left: '0', backgroundColor: 'rgba(0,0,0,0.3)', color: 'white', width: '100%', height: '6.2rem' }}>
            {
                captions.map((caption, index) => <span key={index}>{caption}</span>)
            }
        </div>
    </div>
}